import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function TransformSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#0D1B2A'
  }} data-id="element-334">
      <div className="max-w-4xl mx-auto" data-id="element-335">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-336">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-337" />

          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-16" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-338">
            Ce que ça change
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-339">
            {/* Card 1 */}
            <div className="p-6 md:p-8 rounded-2xl text-center" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-340">
              <h3 className="text-xl font-bold mb-4" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-341">
                Le dimanche soir ?
              </h3>
              <p style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#F5F0E8'
            }} data-id="element-342">
                Tu ne paniques plus.
              </p>
            </div>

            {/* Card 2 */}
            <div className="p-6 md:p-8 rounded-2xl text-center" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-343">
              <h3 className="text-xl font-bold mb-4" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-344">
                Le lundi matin ?
              </h3>
              <p style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#F5F0E8'
            }} data-id="element-345">
                Tu bois ton café. Chaud.
              </p>
            </div>

            {/* Card 3 */}
            <div className="p-6 md:p-8 rounded-2xl text-center" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-346">
              <h3 className="text-xl font-bold mb-4" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-347">
                Le soir ?
              </h3>
              <p style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#F5F0E8'
            }} data-id="element-348">
                Ton cerveau... se tait. Vraiment.
              </p>
            </div>
          </div>

          <div className="mt-10 md:mt-16 text-center text-base md:text-xl leading-relaxed max-w-2xl mx-auto" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#C8C0B0'
        }} data-id="element-349">
            <p className="mb-3 md:mb-4" data-id="element-350">Pas parce que tu as tout fait.</p>
            <p className="mb-4 md:mb-8" data-id="element-351">
              Mais parce que tout ce qui doit être fait est noté quelque part de
              confiance.
            </p>
            <p className="font-bold text-2xl" style={{
            color: '#D4A853',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-352">
              Ton cerveau peut enfin lâcher prise.
            </p>
          </div>

          {/* CTA 2 */}
          <div className="mt-10 md:mt-16 flex flex-col items-center gap-2 md:gap-3" data-id="element-353">
            <button onClick={() => {
            document.getElementById('offer-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="cta-pulse inline-flex items-center gap-2 px-8 py-5 rounded-xl text-base md:text-lg font-semibold transition-transform hover:scale-105 active:scale-95" style={{
            background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
            color: '#0D1B2A',
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 600
          }} data-id="element-354">
              👉 OUI, JE VEUX ÇA
            </button>
            <p className="text-sm font-medium" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-355">
              [ Ebook + 2 Bonus · Téléchargement immédiat ]
            </p>
          </div>
        </div>
      </div>
    </section>;
}